import { Helmet } from "react-helmet";
import Header from "../../../components/common/layout/Header";
import Canonical from "../../../components/common/layout/Canonical";
import { useTranslation } from "react-i18next";
import ShopList from "../../../components/passenger/stores/ShopList";

const Shops = () => {
    const { t } = useTranslation('common');

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.shops.title")}</title>
                <meta name="description" content={t("seo_friendly.shops.desc")} />
            </Helmet>
            <div className="bg-white dark:bg-bgDarkDull">
                <Header type="passenger" />
                <div id="home">
                    <ShopList />
                </div>
            </div>
        </>
    );
};

export default Shops;